// useDidFetch.js
import { useRef } from "react";

export default function useDidFetch() {
  const didFetch = useRef(false);

  const runOnce = (callback) => {
    if (didFetch.current) return;
    didFetch.current = true;
    callback();
  };

  return runOnce;
}
